import {defineComponent, reactive} from '@vue/composition-api';
import {onConfirmPromotion} from "@/components/promotion-popup/promotion-popup-functions";
import axios from "axios";
import {SettingsContext} from "@/utilities/settings-context";
import TransitionGroupSlide from "@/components/transition-group-slide/transition-group-slide.vue";
import { i18n } from '@/utilities/vue-i18n';

export default defineComponent({

    components: {
        TransitionGroupSlide
    },
    setup()
    {
        const model = reactive({

            visible: false,

            scopes: new Array<string>(),

            loaded: false
        });

        const reset = () => {

            model.visible = false;

            model.loaded = false;

            model.scopes = [];
        };

        let callback: (result: boolean) => void = () => false;

        onConfirmPromotion(args => {

            callback = args.callback;

            reset();

            model.visible = true;

            axios.get<Array<string>>(`${SettingsContext.getApiUrl('getTargetScopeDomains')}/${args.id}`).then(targets => {

                model.scopes = targets.data;

                model.scopes = model.scopes.filter(value => value !== 'ledigajobb.se');

                model.scopes = ['ledigajobb.se', ...model.scopes];

                if(model.scopes.length > 10) {

                    const remainings = model.scopes.length - 9;

                    model.scopes = [...model.scopes.splice(0, 9), `+ ${remainings} ${i18n.t('ad-configuration.more-websites')}`];
                }
            });
        });

        const confirm = () => {

            reset();

            callback(true);
        }

        const cancel = () => {

            reset();

            callback(false);
        }

        return {

            model,

            confirm,

            cancel
        };
    }
});
